package com.example.mystybag.login.model

// Simple UI state for the add first bag prompt screen
data class AddFirstBagPromptUIState(
    val dummy: Boolean = true // Data class must have at least one parameter
)
